module.exports = __webpack_public_path__ + "static/media/view cyclic cleanliness.13b9f9de.svg";